import { Container, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material';

export const StyledPageContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(10),
  paddingBlock: theme.spacing(10),
  paddingInline: theme.spacing(5),

  '@media (max-width: 2599px)': {
    paddingInline: theme.spacing(20),
  },

  [theme.breakpoints.down('md')]: {
    paddingInline: theme.spacing(10),
  },

  [theme.breakpoints.down('sm')]: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingInline: theme.spacing(4),
  },

  '@media (max-width: 375px)': {
    paddingInline: theme.spacing(2),
  },
}));

export const StyledPageTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(32),
  fontWeight: 600,
  lineHeight: 1.2,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),

  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.pxToRem(24),
    marginBottom: theme.spacing(1),
  },
}));

export const StyledPageSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(20),
  fontWeight: 400,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(4),

  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.pxToRem(13),
    marginBottom: theme.spacing(3),
  },
}));

export const StyledDirectionalAnalyticsSection = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'stretch',
  padding: theme.spacing(6),
  backgroundColor: theme.palette.background.contrast,
  borderRadius: theme.customShape.borderRadiusXLarge,
  '& > :first-of-type': {
    flex: 1,
    minWidth: 0,
  },
  [theme.breakpoints.down('md')]: {
    marginInline: theme.spacing(-10),
    borderRadius: 0,
    padding: 0,
  },
  [theme.breakpoints.down('sm')]: {
    marginInline: theme.spacing(-4),
  },
  '@media (max-width: 375px)': {
    marginInline: theme.spacing(-2),
  },
}));

export const StyledPinnedCardWrapper = styled(Stack)(({ theme }) => ({
  flex: '0 0 757px',

  '@media (max-width: 1920px)': {
    flex: '0 0 546px',
  },

  '@media (max-width: 1536px)': {
    flex: '0 0 418px',
  },

  '@media (max-width: 1280px)': {
    flex: '0 0 335px',
  },

  [theme.breakpoints.down('md')]: {
    flex: 'unset',
    width: '100%',
  },
}));

export const StyledCarouselWrapper = styled('div')({
  '@media (min-width: 2600px)': {
    marginInline: '-80px',
  },
});

export const StyledCardsContainer = styled(Stack)(({ theme }) => ({
  marginTop: theme.spacing(5),
  gap: theme.spacing(5),
  flexDirection: 'column',
  alignItems: 'center',
  '& > *': {
    width: '100%',
  },
}));

export const StyledCardsRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: theme.spacing(5),
  width: '100%',

  '& > *': {
    flex: 1,
    minWidth: 0,
  },

  '@media (max-width: 960px)': {
    flexDirection: 'column',

    '& > *': {
      width: '100%',
    },
  },
}));

/**
 * Wrapper for each card in a row. Cards size naturally; min-height is applied
 * directly to card DOM nodes by MatchHeightCardsRow to equalise collapsed heights.
 */
export const StyledCardCell = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
}));
